import { render } from "./ELECTED_RESIGNED_DURING_TERM.vue?vue&type=template&id=ef1b41e8"
import script from "./ELECTED_RESIGNED_DURING_TERM.vue?vue&type=script&lang=js"
export * from "./ELECTED_RESIGNED_DURING_TERM.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__